<app-custom-spinner *ngIf="isLoading"></app-custom-spinner>
<div class="impact-active" *ngIf="dataForImpact$ | async as dataForImpact">
  <div class="top-info" [style.backgroundImage]="'url(' + dataForImpact.companyInfo.bg_image_url + ')'" [style.height]="heightPerso">
    <div class="blured-image" *ngIf="dataForImpact.companyInfo.blur_image">
    </div>
    <div class="picture-quote-container">
      <span *ngIf="dataForImpact?.companyInfo?.picture_quote">{{dataForImpact.companyInfo.picture_quote[currentLanguage]}}</span>
    </div>
    <div class="brand-logo" [ngClass]="{'invisible-logo': !dataForImpact.companyInfo.display_logo}">
      <img loading="lazy" [src]="dataForImpact.companyInfo.logo_url" alt="brand-logo">
    </div>
  </div>

  <div class="container-xl">
    <h1 *ngIf="dataForImpact.companyInfo.company_page_title" [innerHTML]="dataForImpact.companyInfo.company_page_title[currentLanguage]"></h1>
    <h1 *ngIf="!dataForImpact.companyInfo.company_page_title">
      {{ "BRAND_PAGE.title_previous_brand_page" | translate }} <b>{{ dataForImpact.companyInfo.name }}</b> {{ "BRAND_PAGE.title_next_brand_page" | translate }}
    </h1>
  </div>
  <div class="no-impact" *ngIf="dataForImpact.programs.all.length === 0 && dataForImpact.projects.length === 0">
    <img loading="lazy" src="assets/icons/no_impact_logo.svg" alt="no impact">
    {{ dataForImpact.companyInfo.name }} {{ "BRAND_PAGE.has_no_impact_brand_page" | translate }}
  </div>
  <ng-container *ngIf="dataForImpact.companyCards?.length > 0">
    <div class="info-cards-container">
      <div *ngFor="let card of dataForImpact.companyCards"
           [class.info-card]="card.template === 'info-card'"
           [class.footer-card]="card.template === 'footer-card'"
           [class.paragraph]="card.template === 'paragraph'"
           [class.bg-very-light-green]="card.template === 'info-card'"
           [class.bg-alt-light-grey]="card.template === 'footer-card'">
        <span *ngIf="card.title" class="title">{{card.title[currentLanguage]}}</span>
        <div *ngIf="card.content" [innerHTML]="card.content[currentLanguage]"></div>
        <button *ngIf="card.cta_title" class="card-button"
                (click)="navigateToUrl(card.cta_url)">{{card.cta_title[currentLanguage]}}</button>
        <div *ngIf="card.footer" class="card-link" [innerHTML]="card.footer[currentLanguage]"></div>
      </div>
    </div>
  </ng-container>

  <div *ngIf="dataForImpact.projects.length !== 0">
    <div class="impact-title" *ngIf="brandEndsInS"> {{ "BRAND_PAGE.impact_title1_brand_page" | translate }}{{ dataForImpact.companyInfo.name }}{{ "BRAND_PAGE.impact_title2s_brand_page" | translate }}</div>
    <div class="impact-title" *ngIf="!brandEndsInS"> {{ "BRAND_PAGE.impact_title1_brand_page" | translate }}{{ dataForImpact.companyInfo.name }}{{ "BRAND_PAGE.impact_title2nots_brand_page" | translate }}</div>
    <p class="impact-subtitle" *ngIf="brandEndsInS">
      {{ "BRAND_PAGE.impact_subtitle1_brand_page" | translate }} {{ dataForImpact.companyInfo.name }}{{ "BRAND_PAGE.impact_subtitle2s_brand_page" | translate }}
    </p>
    <p class="impact-subtitle" *ngIf="!brandEndsInS">
      {{ "BRAND_PAGE.impact_subtitle1_brand_page" | translate }} {{ dataForImpact.companyInfo.name }}{{ "BRAND_PAGE.impact_subtitle2nots_brand_page" | translate }}
    </p>
    <div class="brand-left-cta sans-serif pin-share" [appTooltip]="dataForImpact.companyInfo.slug + '?latest'" [shareType]="{type: rootShare}">
      {{ "BRAND_PAGE.share_brand_page" | translate }}
      <img loading="lazy" class='icon-share' src="/assets/icons/share-very-dark-green.svg" alt="share">
    </div>
    <div class="impact-wrapper">
      <div class="card-wrapper education-card" *ngIf="dataForImpact.impact.education" (click)="openBrandSingleImpactDialog(['education'])">
        <img loading="lazy" src="/assets/icons/north_star/education_color.svg" alt="education" class="card-image">
        <div class="card-number">{{ dataForImpact.impact.education | ceil }}</div>
        <div class="card-kpi">{{ "IMPACT_PAGE.education_impactpage" | translate }}</div>
      </div>
      <div class="card-wrapper biodiversity-card" *ngIf="dataForImpact.impact.biodiversity" (click)="openBrandSingleImpactDialog(['biodiversity'])">
        <img loading="lazy" src="/assets/icons/north_star/biodiversity_color.svg" alt="biodiversity" class="card-image">
        <div class="card-number">{{ dataForImpact.impact.biodiversity | squareMeters }}</div>
        <div class="card-kpi" *ngIf="dataForImpact.impact.biodiversity >= 1">{{ "IMPACT_PAGE.biodiversity_impactpage" | translate }}</div>
        <div class="card-kpi" *ngIf="dataForImpact.impact.biodiversity < 1">{{ "IMPACT_PAGE.biodiversity_square_meters_impactpage" | translate }}</div>
      </div>
      <div class="card-wrapper diverse-actions-card" *ngIf="dataForImpact.impact.diverseActions" (click)="openBrandSingleImpactDialog(['diverse_actions'])">
        <img loading="lazy" src="/assets/icons/north_star/diverse_actions_color.svg" alt="diverse-actions" class="card-image">
        <div class="card-number">{{ dataForImpact.impact.diverseActions | ceil }}</div>
        <div class="card-kpi">{{ "IMPACT_PAGE.diverse_actions_impactpage" | translate }}</div>
      </div>
      <div class="card-wrapper reforestation-card" *ngIf="dataForImpact.impact.reforestation" (click)="openBrandSingleImpactDialog(['reforestation'])">
        <img loading="lazy" src="/assets/icons/north_star/reforestation_color.svg" alt="reforestation" class="card-image">
        <div class="card-number">{{ dataForImpact.impact.reforestation | ceil }}</div>
        <div class="card-kpi">{{ "IMPACT_PAGE.reforestation_impactpage" | translate }}</div>
      </div>
      <div class="card-wrapper health-card" *ngIf="dataForImpact.impact.health" (click)="openBrandSingleImpactDialog(['health'])">
        <img loading="lazy" src="/assets/icons/north_star/health_color.svg" alt="health" class="card-image">
        <div class="card-number">{{ dataForImpact.impact.health | ceil }}</div>
        <div class="card-kpi">{{ "IMPACT_PAGE.health_impactpage" | translate }}</div>
      </div>
      <div class="card-wrapper carbon-offset-card" *ngIf="get_nb_tons()" (click)="openBrandSingleImpactDialog(['reforestation', 'carbon_offset'])">
        <img loading="lazy" src="/assets/icons/north_star/carbon_offset_color.svg" alt="carbon-offset" class="card-image">
        <div class="card-number">{{ get_nb_tons() | ceil }}</div>
        <div class="card-kpi">{{ "IMPACT_PAGE.carbon_offset_impactpage" | translate }}</div>
      </div>
      <div class="card-wrapper zero-waste-card" *ngIf="dataForImpact.impact.zeroWaste" (click)="openBrandSingleImpactDialog(['zero_waste'])">
        <img loading="lazy" src="/assets/icons/north_star/zero_waste_color.svg" alt="zero-waste" class="card-image">
        <div class="card-number">{{ dataForImpact.impact.zeroWaste | ceil }}</div>
        <div class="card-kpi">{{ "IMPACT_PAGE.zero_waste_impactpage" | translate }}</div>
      </div>
      <div class="card-wrapper inclusiveness-card" *ngIf="dataForImpact.impact.inclusiveness" (click)="openBrandSingleImpactDialog(['inclusiveness'])">
        <img loading="lazy" src="/assets/icons/north_star/inclusiveness_color.svg" alt="inclusiveness" class="card-image">
        <div class="card-number">{{ dataForImpact.impact.inclusiveness | ceil }}</div>
        <div class="card-kpi">{{ "IMPACT_PAGE.inclusiveness_impactpage" | translate }}</div>
      </div>
    </div>
    <ng-container *ngIf="dataForImpact?.noKpiProject" >
      <app-research-impact-banner
        [noKpiProject]="dataForImpact.noKpiProject"
        [styles]="'margin: 0 auto 90px;'"
      >
      </app-research-impact-banner>
    </ng-container>

    <button class="brand-left-cta yellow larger sans-serif" (click)="openBrandAllImpactDialog()">
      {{ "BRAND_PAGE.see_all_brand_page" | translate }}
    </button>

    <div class="impact-geo-title" *ngIf="brandEndsInS">
      {{ "BRAND_PAGE.impact_footprint_title1_brand_page" | translate }} {{ dataForImpact.companyInfo.name }}{{ "BRAND_PAGE.impact_footprint_title2s_brand_page" | translate }}
    </div>
    <div class="impact-geo-title" *ngIf="!brandEndsInS">
      {{ "BRAND_PAGE.impact_footprint_title1_brand_page" | translate }} {{ dataForImpact.companyInfo.name }}{{ "BRAND_PAGE.impact_footprint_title2nots_brand_page" | translate }}
    </div>

    <div class="charts" *ngIf="dataForImpact">
      <app-chart [series]="dataForImpact.chart['all'].series"></app-chart>
      <app-geochart [data]="dataForImpact.chartMap['all']"></app-geochart>
    </div>
  </div>

    <div class="campaigns-title" *ngIf="brandEndsInS && previousCampaigns().length > 0 && dataForImpact.currentProgram">
      {{ "BRAND_PAGE.campaign_title1_brand_page" | translate }}{{ dataForImpact.companyInfo.name }}{{ "BRAND_PAGE.campaign_title2s_brand_page" | translate }}
    </div>
    <div class="campaigns-title" *ngIf="!brandEndsInS && previousCampaigns().length > 0 && dataForImpact.currentProgram">
      {{ "BRAND_PAGE.campaign_title1_brand_page" | translate }} {{ dataForImpact.companyInfo.name }}{{ "BRAND_PAGE.campaign_title2nots_brand_page" | translate }}
    </div>
    <div class="current-program-section" *ngIf="dataForImpact.currentProgram">
      <div class="campaigns-title-mobile">
        {{ "BRAND_PAGE.campaign_title_brand_page" | translate }} {{ dataForImpact.companyInfo.name }}
      </div>
      <div class="current-program-container">
        <div class="image-wrapper" [style]="getBackgroundImageUrl()"></div>
        <div class="text-wrapper">
          <a [routerLink]="url_currentProgram()" class="project-heading">{{ dataForImpact.currentProgram.title[currentLanguage] }}</a>
          <div class="project-subheading">{{ "BRAND_PAGE.until_brand_page" | translate }} {{ dataForImpact.currentProgram.end_date[currentLanguage] }}</div>
          <div class="project-desc" [innerHTML]="dataForImpact.currentProgram.text[currentLanguage]"></div>
          <button class="project-action-button green sans-serif" [routerLink]="url_currentProgram()">
            {{ "BRAND_PAGE.cta_brand_page" | translate }}
          </button>
          </div>
        </div>
      </div>
      <div *ngIf="previousCampaigns().length > 0">
        <div class="previous-campaigns-title"> {{ "BRAND_PAGE.previous_campaign_brand_page" | translate }}</div>
        <div *ngIf="previousCampaigns().length > 1" class="cards-wrapper previous-campaign-grid">
          <div *ngFor="let campaign of previousCampaigns() | slice : 0:paginationLimit ">
            <div class="previous-campaign-image" [style.backgroundImage]="'url(' + campaign.picture_thumbnail + ')'"></div>
            <div class="previous-campaign-info">
              <div class="title-previous-campaign">{{campaign.title[currentLanguage]}}</div>
              <div class="date-previous-campaign">{{ "BRAND_PAGE.from_brand_page" | translate }} {{ campaign.start_date_natural[currentLanguage] }} {{ "BRAND_PAGE.to_brand_page" | translate }} {{ campaign.end_date_natural[currentLanguage] }}</div>
              <div class="text-previous-campaign"> {{campaign.subtitle[currentLanguage]}}</div>
              <div class="impact-popup-link" (click)="openDialog(campaign.id, campaign.type)">{{ "BRAND_PAGE.see_impact_brand_page" | translate }}</div>
            </div>
          </div>
        </div>
        <div *ngIf="previousCampaigns().length === 1" class="cards-wrapper-solo previous-campaign-grid-solo">
          <div *ngFor="let campaign of previousCampaigns() | slice : 0:paginationLimit " class="alignment">
            <div class="previous-campaign-image-solo" [style.backgroundImage]="'url(' + campaign.picture_thumbnail + ')'"></div>
            <div class="previous-campaign-info">
              <div class="title-previous-campaign">{{campaign.title[currentLanguage]}}</div>
              <div class="date-previous-campaign">{{ "BRAND_PAGE.from_brand_page" | translate }} {{ campaign.start_date_natural[currentLanguage] }} {{ "BRAND_PAGE.to_brand_page" | translate }} {{ campaign.end_date_natural[currentLanguage] }}</div>
              <br>
              <div class="text-previous-campaign">{{campaign.subtitle[currentLanguage]}}...</div>
              <div class="impact-popup-link-solo" (click)="openDialog(campaign.id, campaign.type)">{{ "BRAND_PAGE.see_impact_brand_page" | translate }}</div>
            </div>
          </div>
        </div>
      </div>

    <div class="button-wrapper" *ngIf="paginationLimit < previousCampaigns()?.length">
      <button class="brand-left-cta yellow sans-serif" (click)="showMore()">
        {{ "BRAND_PAGE.see_more_brand_page" | translate }}
      </button>
    </div>

    <div *ngIf="dataForImpact.projects.length > 0" class="impact-carousel">
      <div class="projects-supported-title">{{ "BRAND_PAGE.projects_supported_brand_page" | translate }}</div>
      <app-project-brand-carousel [projectsSupported]="dataForImpact.projects"></app-project-brand-carousel>
    </div>

    <div class="about" *ngIf="dataForImpact.companyInfo.description !== null">
      <div class="about-title">
        {{ "BRAND_PAGE.about_brand_page" | translate }}
        <span class="underline">
          <a [href]="dataForImpact.companyInfo.url" class="underline" target="_blank"> {{ dataForImpact.companyInfo.name }}</a>
        </span>
      </div>
      <div class="link-wrapper">
        <a *ngIf="dataForImpact.companyInfo.linkedin_url?.trim()" [href]="dataForImpact.companyInfo.linkedin_url"
           target="_blank">
          <img loading="lazy" src="/assets/icons/linkedin-blue.svg" alt="linkedin" class="social-network">
        </a>
        <a *ngIf="dataForImpact.companyInfo.facebook_url?.trim()" [href]="dataForImpact.companyInfo.facebook_url"
           target="_blank">
          <img loading="lazy" src="/assets/icons/facebook-blue.svg" alt="facebook" class="social-network">
        </a>
        <a *ngIf="dataForImpact.companyInfo.twitter_url?.trim()" [href]="dataForImpact.companyInfo.twitter_url"
           target="_blank">
          <img loading="lazy" src="/assets/icons/twitter-blue.svg" alt="twitter" class="social-network">
        </a>
        <a *ngIf="dataForImpact.companyInfo.instagram_url?.trim()" [href]="dataForImpact.companyInfo.instagram_url"
           target="_blank">
          <img loading="lazy" src="/assets/icons/instagram-blue.svg" alt="instagram" class="social-network">
        </a>
      </div>
      <div class="text-about" [innerHTML]="dataForImpact.companyInfo.description[currentLanguage]"></div>
    </div>

    <div class="about" *ngIf="dataForImpact.companyInfo.external_impact !== null">
      <div class="impact-footprint-title">
        {{ "BRAND_PAGE.also_emporewered_title_brand_page" | translate }} {{ dataForImpact.companyInfo.name }}
      </div>
      <div class="text-about">
        <div class="title-text-about">{{ "BRAND_PAGE.also_emporewered_text_brand_page" | translate }}</div>
        <div class="external-impact" [innerHTML]="dataForImpact.companyInfo.external_impact[currentLanguage]"></div>
      </div>
    </div>

    <div class="media-carousel" *ngIf="mediaList.length > 0">
      <app-carousel [mediaContent]="mediaList"></app-carousel>
    </div>

</div>
<app-subscribe-banner></app-subscribe-banner>
